import { create } from 'zustand';
import { Roles } from '@/constants/roles';

interface VerifyStore {
  checkId: string;
  setCheckId: (id: string) => void;
}

export const useVerifyStore = create<VerifyStore>((set) => ({
  checkId: '',
  setCheckId: (id: string) => set({ checkId: id }),
}));
